import { FC, useState } from "react";
import type { DonchianChannelSettings } from "../../model";
import styles from "./AcceleratorOscillatorInputsTab.module.css";

interface Props {
  settings: DonchianChannelSettings;
  onChange: (settings: DonchianChannelSettings) => void;
}

export const DonchianChannelInputsTab: FC<Props> = ({ settings, onChange }) => {
  const [value, setValue] = useState(String(settings.period));

  const handleBlur = () => {
    const parsed = parseInt(value, 10);
    const clamped = isNaN(parsed) ? settings.period : Math.min(Math.max(5, parsed), 200);
    setValue(String(clamped));
    onChange({ ...settings, period: clamped });
  };

  return (
    <div className={styles.tab}>
      <div className={styles.row}>
        <span className={styles.label}>Period</span>
        <input
          type="number"
          className={styles.input}
          min={5}
          max={200}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={handleBlur}
        />
      </div>
    </div>
  );
};
